import React from 'react';

interface TableIconProps {
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}

export default function TableIcon({ 
  size = 24, 
  className = "", 
  style = {} 
}: TableIconProps) {
  return (
    <img 
      src="/assets/images/mesita.png" 
      alt="Mesa" 
      className={className}
      style={{ 
        width: size, 
        height: size, 
        objectFit: 'contain',
        ...style 
      }}
    />
  );
} 